// eslint-disable-next-line @typescript-eslint/triple-slash-reference, spaced-comment
/// <reference types="@ps/web-spade-sdk/types" />
import { Sites } from '@ps/platform-message-framework/common/Sites';
import type { InitSchema } from '@ps/web-spade-sdk/schema';
import { useRef } from 'react';
import { useSelector } from 'react-redux';

import { select } from '../../';

const getEnvironment = (host: string) => {
  if (host.includes('local')) {
    return 'local';
  }

  if (host.includes('qc')) {
    return 'dev:qc-dev';
  }

  return 'production';
};

export const useSpadeSdk = () => {
  const host = useSelector(select.location.getHost);
  const locale = useSelector(select.locale.get);
  const siteId = useSelector(select.cms.getSiteId);
  const siteName = useSelector(select.cms.getSiteName);

  const spadeSdk = useRef(
    window.Spade?.init({
      locale: locale as InitSchema['locale'],
      brand: siteId === Sites.IT_SISAL_EXT ? 'sisal' : 'pokerstars',
      site: siteName.toLowerCase() as InitSchema['site'],
      environment: getEnvironment(host)
    })
  );

  return spadeSdk.current;
};
